module.exports = __webpack_public_path__ + "static/media/welcome-banner-logo.43b16a64.svg";